import { useSyncExternalStore } from "react";

function useMediaQuery(query) {
    const getSnapshot = () => {
        if (typeof window === "undefined") return false;
        return window.matchMedia(query).matches;
    };

    const subscribe = (callback) => {
        if (typeof window === "undefined") return () => { };
        const mediaQueryList = window.matchMedia(query);
        mediaQueryList.addEventListener("change", callback);
        return () => mediaQueryList.removeEventListener("change", callback);
    };

    const getServerSnapshot = () => false;

    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export default useMediaQuery;
